"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const complex_utils_1 = require("complex-utils");
const ExternalIframe_vue_1 = __importDefault(require("@/components/data/ExternalIframe.vue"));
const utils_1 = require("@/config/utils");
const vue_1 = require("vue");
const config = {
    preUrl: ''
};
(0, complex_utils_1.resetEnvData)(() => {
    config.preUrl = 'http://wztest.wuzheng.com.cn/vehicle/index.html#';
    config.preUrl = 'http://localhost:5818/index.html#';
}, {
    info: '开发环境下更改默认的iframe指向！'
});
exports.default = (0, vue_1.defineComponent)({
    name: 'LockLog',
    components: {
        ExternalIframe: ExternalIframe_vue_1.default
    },
    props: {
        vin: {
            type: String,
            required: true
        },
        agreement: {
            type: String,
            required: false
        },
        width: {
            type: Number,
            required: true
        },
        height: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            preUrl: config.preUrl
        };
    },
    computed: {
        target() {
            const options = {};
            const redirect = `/vehicle/control/info/4/${this.vin}/lock/${this.agreement}/${JSON.stringify(options)}`;
            const target = '/external/auto/';
            return target + encodeURIComponent(redirect);
        }
    },
    methods: {
        formatStyle(num) {
            return (0, utils_1.formatStyle)(num);
        }
    }
});
